import withStyles from "react-jss"

const styles = {
  container: {
    width: "100%",
    "@media only screen and (max-width: 840px)": {
      padding: "0 16px",
    },
  },
  textContainer: {
    display: "flex",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    color: "white",
    fontSize: "48px",
    fontFamily: "WiredMono",
    textTransform: "uppercase",
  },
}

const SectionDivider = ({ classes, title }) => {
  return (
    <section className={classes.container}>
      <article className={classes.textContainer}>
        <h1 className={classes.title}>{title}</h1>
      </article>
    </section>
  )
}

export default withStyles(styles)(SectionDivider)
